import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var RentIncreaseData =
/*#__PURE__*/
function () {
  function RentIncreaseData() {
    _classCallCheck(this, RentIncreaseData);
  }

  _createClass(RentIncreaseData, [{
    key: "GetRentIncrease",
    value: function () {
      var _GetRentIncrease = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(headerId, projectId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/GetRentIncrease/".concat(headerId, "/").concat(projectId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetRentIncrease(_x, _x2) {
        return _GetRentIncrease.apply(this, arguments);
      }

      return GetRentIncrease;
    }()
  }, {
    key: "GetHeaderList",
    value: function () {
      var _GetHeaderList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(isAdmin, projectId, statusId, year) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/GetRentHeaderList/".concat(isAdmin, "/").concat(projectId, "/").concat(statusId, "/").concat(year)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetHeaderList(_x3, _x4, _x5, _x6) {
        return _GetHeaderList.apply(this, arguments);
      }

      return GetHeaderList;
    }()
  }, {
    key: "GetMCHeaderList",
    value: function () {
      var _GetMCHeaderList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectId, dropdownId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/GetMCHeaderList/".concat(projectId, "/").concat(dropdownId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetMCHeaderList(_x7, _x8) {
        return _GetMCHeaderList.apply(this, arguments);
      }

      return GetMCHeaderList;
    }()
  }, {
    key: "GetDropdownVals",
    value: function () {
      var _GetDropdownVals = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(isAdmin, projectId, statusId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/GetDropdownVals/".concat(isAdmin, "/").concat(projectId, "/").concat(statusId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function GetDropdownVals(_x9, _x10, _x11) {
        return _GetDropdownVals.apply(this, arguments);
      }

      return GetDropdownVals;
    }()
  }, {
    key: "IsTaxCreditOnly",
    value: function () {
      var _IsTaxCreditOnly = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(projectId, headerId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/IsTaxCreditOnly/".concat(projectId, "/").concat(headerId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function IsTaxCreditOnly(_x12, _x13) {
        return _IsTaxCreditOnly.apply(this, arguments);
      }

      return IsTaxCreditOnly;
    }()
  }, {
    key: "GetPropertyList",
    value: function () {
      var _GetPropertyList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(userId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.get("/api/GetPropertyList/".concat(userId)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function GetPropertyList(_x14) {
        return _GetPropertyList.apply(this, arguments);
      }

      return GetPropertyList;
    }()
  }, {
    key: "CheckPermissionToProject",
    value: function () {
      var _CheckPermissionToProject = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(userId, projectId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.get("/api/CheckPermissionToProject/".concat(userId, "/").concat(projectId)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function CheckPermissionToProject(_x15, _x16) {
        return _CheckPermissionToProject.apply(this, arguments);
      }

      return CheckPermissionToProject;
    }()
  }, {
    key: "GetRentTypes",
    value: function () {
      var _GetRentTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.get("/api/GetRentTypes"));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function GetRentTypes() {
        return _GetRentTypes.apply(this, arguments);
      }

      return GetRentTypes;
    }()
  }, {
    key: "GetRoomAndRentTypes",
    value: function () {
      var _GetRoomAndRentTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.get("/api/GetRoomAndRentTypes"));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function GetRoomAndRentTypes() {
        return _GetRoomAndRentTypes.apply(this, arguments);
      }

      return GetRoomAndRentTypes;
    }()
  }, {
    key: "GetScheduleIIData",
    value: function () {
      var _GetScheduleIIData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(headerId) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.get("/api/GetScheduleIIData/".concat(headerId)));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function GetScheduleIIData(_x17) {
        return _GetScheduleIIData.apply(this, arguments);
      }

      return GetScheduleIIData;
    }()
  }, {
    key: "ListDownload",
    value: function () {
      var _ListDownload = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(projectId, headerId, budgetYear) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", axios.get("/api/RentIncreaseListDownload/".concat(projectId, "/").concat(headerId, "/").concat(budgetYear)));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function ListDownload(_x18, _x19, _x20) {
        return _ListDownload.apply(this, arguments);
      }

      return ListDownload;
    }()
  }, {
    key: "AdminChangeStatus",
    value: function () {
      var _AdminChangeStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(HeaderId, StatusId) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", axios.get("api/RentIncreaseAdminChangeStatus/".concat(HeaderId, "/").concat(StatusId)));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function AdminChangeStatus(_x21, _x22) {
        return _AdminChangeStatus.apply(this, arguments);
      }

      return AdminChangeStatus;
    }()
  }, {
    key: "UploadScheduleIIDoc",
    value: function () {
      var _UploadScheduleIIDoc = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(files, projectId, requestId, fileName) {
        var formData;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                formData = new FormData();
                files.forEach(function (file) {
                  formData.append("files[]", file);
                });
                formData.append("projectId", projectId);
                formData.append("requestId", requestId);
                formData.append("fileName", fileName);
                formData.append("documentType", "ScheduleII");
                return _context13.abrupt("return", axios.post("/api/RentIncreaseFileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function UploadScheduleIIDoc(_x23, _x24, _x25, _x26) {
        return _UploadScheduleIIDoc.apply(this, arguments);
      }

      return UploadScheduleIIDoc;
    }()
  }, {
    key: "SaveProgress",
    value: function () {
      var _SaveProgress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(tableData, headerId, rentIncreaseTypeId, projectId, statusId, certId, comments, effectiveDate, tenantsNotified, submittedAsException) {
        var RoomRentIncreaseRequest;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                RoomRentIncreaseRequest = [];
                tableData.forEach(function (x) {
                  return RoomRentIncreaseRequest.push({
                    RoomRentIncreaseRequestId: x.roomRentIncreaseRequestId,
                    ProjectRoomTypeRentId: x.projectRoomTypeRentId,
                    RequestedRent: x.requestedRents,
                    RentTypeId: x.rentType.value
                  });
                });
                return _context14.abrupt("return", axios.post("/api/saveRentIncreaseProgress", {
                  RentIncreaseRequestHeaderId: headerId,
                  RentIncreaseTypeId: rentIncreaseTypeId,
                  StatusId: statusId,
                  ProjectId: projectId,
                  ManagementCompanyComments: comments,
                  TenantsNotified: tenantsNotified,
                  RoomRentIncreaseRequest: RoomRentIncreaseRequest,
                  RentEffectiveDate: effectiveDate,
                  CertificationId: certId,
                  SubmittedAsException: submittedAsException
                }));

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function SaveProgress(_x27, _x28, _x29, _x30, _x31, _x32, _x33, _x34, _x35, _x36) {
        return _SaveProgress.apply(this, arguments);
      }

      return SaveProgress;
    }()
  }, {
    key: "GetReviewCashFlow",
    value: function () {
      var _GetReviewCashFlow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(headerId) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", axios.get("/api/GetReviewCashFlow/".concat(headerId)));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function GetReviewCashFlow(_x37) {
        return _GetReviewCashFlow.apply(this, arguments);
      }

      return GetReviewCashFlow;
    }()
  }, {
    key: "GetReviewTaxCredit",
    value: function () {
      var _GetReviewTaxCredit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(headerId) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", axios.get("/api/GetReviewTaxCredit/".concat(headerId)));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function GetReviewTaxCredit(_x38) {
        return _GetReviewTaxCredit.apply(this, arguments);
      }

      return GetReviewTaxCredit;
    }()
  }, {
    key: "GetReviewWorksheet",
    value: function () {
      var _GetReviewWorksheet = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17(headerId) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", axios.get("/api/GetReviewWorksheet/".concat(headerId)));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function GetReviewWorksheet(_x39) {
        return _GetReviewWorksheet.apply(this, arguments);
      }

      return GetReviewWorksheet;
    }()
  }, {
    key: "DeleteRow",
    value: function () {
      var _DeleteRow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18(row) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", axios.post("/api/RentIncrease/DeleteRow/".concat(row.projectRoomTypeRentId)));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function DeleteRow(_x40) {
        return _DeleteRow.apply(this, arguments);
      }

      return DeleteRow;
    }()
  }, {
    key: "CreateNewRentRow",
    value: function () {
      var _CreateNewRentRow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19(rentTypeId, roomTypeId, currentRent, requestedRent, numUnits, headerId, projectId) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", axios.get("/api/CreateNewRentRow/".concat(rentTypeId, "/").concat(roomTypeId, "/").concat(currentRent, "/").concat(requestedRent, "/").concat(numUnits, "/").concat(headerId, "/").concat(projectId)));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function CreateNewRentRow(_x41, _x42, _x43, _x44, _x45, _x46, _x47) {
        return _CreateNewRentRow.apply(this, arguments);
      }

      return CreateNewRentRow;
    }()
  }, {
    key: "SaveCashFlow",
    value: function () {
      var _SaveCashFlow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20(headerId, tableData, comments, userId, cashAnalysis, effectiveDate) {
        var RoomRentIncreaseRequest;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                RoomRentIncreaseRequest = [];
                tableData.forEach(function (x) {
                  return RoomRentIncreaseRequest.push({
                    RoomRentIncreaseRequestId: x.roomRentIncreaseRequestId,
                    ApprovedRent: x.approvedRent,
                    RentTypeId: x.rentType.value,
                    RequestedRent: x.requestedRents,
                    ProjectRoomTypeRent: {
                      NumberOfUnits: x.numUnits,
                      RentAmount: x.currentRents
                    }
                  });
                });
                return _context20.abrupt("return", axios.post("/api/SaveCashFlow", {
                  RentIncreaseRequestHeaderId: headerId,
                  Comments: comments,
                  ReviewedByUserId: userId,
                  RentEffectiveDate: effectiveDate,
                  RoomRentIncreaseRequest: RoomRentIncreaseRequest,
                  RentIncreaseCashAnalysis: cashAnalysis
                }));

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function SaveCashFlow(_x48, _x49, _x50, _x51, _x52, _x53) {
        return _SaveCashFlow.apply(this, arguments);
      }

      return SaveCashFlow;
    }()
  }, {
    key: "SaveTaxCredit",
    value: function () {
      var _SaveTaxCredit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21(headerId, tableData, findingsInNonComplianceLog, aodNonComplianceIssues, sec42Requirements, rentRollRevied, openInspection, comments, userId, effectiveDate, extendedUsePeriod) {
        var RoomRentIncreaseRequest;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                RoomRentIncreaseRequest = [];
                tableData.forEach(function (x) {
                  return RoomRentIncreaseRequest.push({
                    RoomRentIncreaseRequestId: x.roomRentIncreaseRequestId,
                    ApprovedRent: x.approvedRent,
                    MedianPercent: x.medianPercentage,
                    MedianMaxRent: x.maxRents,
                    RentTypeId: x.rentType.value,
                    RequestedRent: x.requestedRents,
                    ProjectRoomTypeRent: {
                      NumberOfUnits: x.numUnits,
                      RentAmount: x.currentRents
                    }
                  });
                });
                return _context21.abrupt("return", axios.post("/api/SaveTaxCredit", {
                  RentIncreaseRequestHeaderId: headerId,
                  AODNonComplianceIssues: aodNonComplianceIssues,
                  FindingsInNonComplianceLog: findingsInNonComplianceLog,
                  Sec42Requirements: sec42Requirements,
                  OpenInspection: openInspection,
                  RentRollRevied: rentRollRevied,
                  ExtendedUsePeriod: extendedUsePeriod,
                  Comments: comments,
                  ReviewedByUserId: userId,
                  RentEffectiveDate: effectiveDate,
                  RoomRentIncreaseRequest: RoomRentIncreaseRequest
                }));

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      function SaveTaxCredit(_x54, _x55, _x56, _x57, _x58, _x59, _x60, _x61, _x62, _x63, _x64) {
        return _SaveTaxCredit.apply(this, arguments);
      }

      return SaveTaxCredit;
    }()
  }, {
    key: "SaveWorksheet",
    value: function () {
      var _SaveWorksheet = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22(headerId, tableData, budgetApproved, openInspection, aodNonComplianceIssues, mitasOpenIssues, r4rBalanceTooLow, findingsInNonComplianceLog, afsReviewed, rentRollRevied, comments, userId, effectiveDate, extendedUsePeriod) {
        var RoomRentIncreaseRequest;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                RoomRentIncreaseRequest = [];
                tableData.forEach(function (x) {
                  return RoomRentIncreaseRequest.push({
                    RoomRentIncreaseRequestId: x.roomRentIncreaseRequestId,
                    ApprovedRent: x.approvedRent,
                    MedianPercent: x.medianPercentage,
                    MedianMaxRent: x.maxRents,
                    RequestedRent: x.requestedRents,
                    ProjectRoomTypeRent: {
                      NumberOfUnits: x.numUnits,
                      RentAmount: x.currentRents
                    }
                  });
                });
                return _context22.abrupt("return", axios.post("/api/SaveWorksheet", {
                  RentIncreaseRequestHeaderId: headerId,
                  BudgetApproved: budgetApproved,
                  OpenInspection: openInspection,
                  AODNonComplianceIssues: aodNonComplianceIssues,
                  MITASOpenIssues: mitasOpenIssues,
                  R4RBalanceTooLow: r4rBalanceTooLow,
                  FindingsInNonComplianceLog: findingsInNonComplianceLog,
                  AFSReviewed: afsReviewed,
                  RentRollRevied: rentRollRevied,
                  ExtendedUsePeriod: extendedUsePeriod,
                  Comments: comments,
                  ReviewedByUserId: userId,
                  RentEffectiveDate: effectiveDate,
                  RoomRentIncreaseRequest: RoomRentIncreaseRequest
                }));

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      function SaveWorksheet(_x65, _x66, _x67, _x68, _x69, _x70, _x71, _x72, _x73, _x74, _x75, _x76, _x77, _x78) {
        return _SaveWorksheet.apply(this, arguments);
      }

      return SaveWorksheet;
    }()
  }, {
    key: "ApproveRequest",
    value: function () {
      var _ApproveRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23(headerId, isEup) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", axios.get("/api/ApproveRequest/".concat(headerId, "/").concat(isEup)));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      function ApproveRequest(_x79, _x80) {
        return _ApproveRequest.apply(this, arguments);
      }

      return ApproveRequest;
    }()
  }, {
    key: "DenyRequest",
    value: function () {
      var _DenyRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24(headerId) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", axios.get("/api/DenyRequest/".concat(headerId)));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      function DenyRequest(_x81) {
        return _DenyRequest.apply(this, arguments);
      }

      return DenyRequest;
    }()
  }, {
    key: "StartReview",
    value: function () {
      var _StartReview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25(requestId) {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", axios.get("/api/RentIncrease/StartReview/".concat(requestId)));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      function StartReview(_x82) {
        return _StartReview.apply(this, arguments);
      }

      return StartReview;
    }()
  }, {
    key: "UnSubmitRentIncrease",
    value: function () {
      var _UnSubmitRentIncrease = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26(requestId) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.abrupt("return", axios.post("api/RentIncrease/UnSubmit", requestId, {
                  headers: {
                    "Content-Type": "application/json"
                  }
                }));

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      function UnSubmitRentIncrease(_x83) {
        return _UnSubmitRentIncrease.apply(this, arguments);
      }

      return UnSubmitRentIncrease;
    }()
  }, {
    key: "UploadFile",
    value: function () {
      var _UploadFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27(files, projectId, requestId, fileName) {
        var formData;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                formData = new FormData();
                files.forEach(function (file) {
                  formData.append("files[]", file);
                });
                formData.append("projectId", projectId);
                formData.append("requestId", requestId);
                formData.append("fileName", fileName);
                formData.append("documentType", "test");
                return _context27.abrupt("return", axios.post("/api/RentIncreaseFileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 7:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      function UploadFile(_x84, _x85, _x86, _x87) {
        return _UploadFile.apply(this, arguments);
      }

      return UploadFile;
    }()
  }, {
    key: "ForceRequireBudget",
    value: function () {
      var _ForceRequireBudget = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28(ProjectId) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", axios.get("/api/RentIncreaseForceRequireBudget/".concat(ProjectId)));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      function ForceRequireBudget(_x88) {
        return _ForceRequireBudget.apply(this, arguments);
      }

      return ForceRequireBudget;
    }()
  }, {
    key: "RemoveRiPermissions",
    value: function () {
      var _RemoveRiPermissions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29(ProjectId) {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", axios.post("/api/RentIncrease/RemoveRiPermissions/".concat(ProjectId)));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));

      function RemoveRiPermissions(_x89) {
        return _RemoveRiPermissions.apply(this, arguments);
      }

      return RemoveRiPermissions;
    }()
  }, {
    key: "GetFiles",
    value: function () {
      var _GetFiles = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30(projectId, headerId) {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                return _context30.abrupt("return", axios.get("/api/GetFiles/".concat(projectId, "/").concat(headerId)));

              case 1:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30);
      }));

      function GetFiles(_x90, _x91) {
        return _GetFiles.apply(this, arguments);
      }

      return GetFiles;
    }()
  }, {
    key: "GetFiles",
    value: function () {
      var _GetFiles2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee31(projectId, headerId) {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", axios.get("/api/GetFiles/".concat(projectId, "/").concat(headerId)));

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));

      function GetFiles(_x92, _x93) {
        return _GetFiles2.apply(this, arguments);
      }

      return GetFiles;
    }()
  }, {
    key: "GetRentIncreasePercentageByYear",
    value: function () {
      var _GetRentIncreasePercentageByYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee32(year) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                return _context32.abrupt("return", axios.get("/api/GetRentIncreasePercentageByYear/".concat(year)));

              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));

      function GetRentIncreasePercentageByYear(_x94) {
        return _GetRentIncreasePercentageByYear.apply(this, arguments);
      }

      return GetRentIncreasePercentageByYear;
    }()
  }]);

  return RentIncreaseData;
}();

export default new RentIncreaseData();